module.exports = __webpack_public_path__ + "static/img/no-data-txt.48a5223.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding/mb/no-data-txt.png
// module id = 1a4E
// module chunks = 1